import { Box, Grid, IconButton, Stack } from "@mui/material";
import React, { useState } from "react";
import QHSE from "./QHSE";

const Accompagnement = () => {
  const [show, setShow] = useState(1);

  return (
    <Box>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={2}
      >
        <Grid item xs>
          <QHSE />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Accompagnement;
